<!--财务审核价格并入库--镜架-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog">
    <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="query-table">
        <tr class="noborder">
          <td align="right" width="60">入&nbsp;&nbsp;&nbsp;&nbsp;库：</td>
          <td width="160">
           {{controlData.cangkuname}}
          </td>
          <td align="right" width="60">供应商：</td>
          <td width="360">
            {{controlData.pcustomer}}
          </td>
        </tr>
        <tr class="noborder" style="display: none">
          <td align="right">订单号：</td>
          <td>{{controlData.erpserial}}</td>
          <td align="right">时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间：</td>
          <td>{{controlData.adddate}}</td>
        </tr>
        <tr class="noborder">
          <td></td>
          <td>总数:{{totalnumber}} 、采购总额：{{totalprice.toFixed(2)}}</td>
          <td></td>
          <td style="padding-left: 90px" v-if="showexcel">
            &nbsp;&nbsp;<a href="./static/file/镜架导入模板.xlsx" >导入模板</a>&nbsp;&nbsp;&nbsp;
            <el-button type="warning" v-on:click="jingjiaupload" size="mini">导 入</el-button>
          </td>
        </tr>
        <tr class="noborder">
          <td colspan="6">
            <el-card shadow="hover" v-if="!onlychangecost">
              <span style="color: #02BAF0">批量修改选择项：</span>
              <el-select style="margin-right: 30px" v-model="batch.lensrule" placeholder="修改镜片策略" size="mini" @change="changeLens('lensrule')" v-if="lensData.length>0&&showexcel">
                <el-option label="" value=""></el-option>
                <el-option label="不使用策略" value="no"></el-option>
                <el-option
                  v-for="item in lensData"
                  :key="item.unitguid"
                  :label="item.title"
                  :value="item.unitguid">
                </el-option>
              </el-select>
              修改采购价：
              <el-input-number v-model="batch.costprice" size="mini" @change="changeLens('costprice')"
                               onfocus="this.select()" :controls="false" style="width: 106px;margin-right: 30px"></el-input-number>
              修改市场价
              <el-input-number v-model="batch.saleprice" size="mini" @change="changeLens('saleprice')"
                               onfocus="this.select()" :controls="false" style="width: 106px;"></el-input-number>
            </el-card>
            <el-table
              :data="tableData"
              size="mini"
              stripe ref="multipleTable"
              border @selection-change="handleSelectionChange"
              style="width: 100%;">
              <el-table-column
                prop="id"
                align="center"
                label="序号"
                width="50">
              </el-table-column>
              <!--<el-table-column-->
                <!--prop="seedcode"-->
                <!--label="编码"-->
                <!--align="center"-->
                <!--width="130"-->
                <!--header-align="center">-->
              <!--</el-table-column>-->
              <!--<el-table-column-->
                <!--prop="model"-->
                <!--label="型号"-->
                <!--width="90" fixed-->
                <!--align="center"-->
                <!--header-align="center">-->
              <!--</el-table-column>-->
              <el-table-column
                prop="seedname"
                label="名称"
                align="center"
                width="250" :show-overflow-tooltip="true"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="packagesize"
                label="规格"
                width="160" :show-overflow-tooltip="true"
                align="left"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="totalnumber"
                label="数量"
                align="center"
                width="80"
                header-align="center">
                <template slot-scope="scope">
                 {{scope.row.totalnumber}}
                </template>
              </el-table-column>
              <el-table-column
                prop="lensrule" v-if="lensData.length>0&&showexcel&&!onlychangecost"
                label="镜片策略"
                align="center"
                width="150"
                header-align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.lensrule" placeholder="请选择" size="mini">
                    <el-option label="不使用策略" value="no"></el-option>
                    <el-option
                      v-for="item in lensData"
                      :key="item.unitguid"
                      :label="item.title"
                      :value="item.unitguid">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                prop="costprice"
                label="采购单价"
                align="left"  width="100"
                header-align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.costprice" size="mini" @change="checkCostNum(scope.row)" onfocus="this.select()" style="width: 76px"
                                   :ref='scope.row.costID'
                                   @keyup.enter.native="validateCounts(scope.row,scope.$index, $event,'costID')"
                                   @keyup.down.native="validateCounts(scope.row,scope.$index, $event,'costID')"
                                   @keyup.up.native="validateCounts(scope.row,scope.$index, $event,'costID')"/>
                </template>
              </el-table-column>
              <el-table-column
                prop="saleprice" v-if="!onlychangecost"
                label="市场价"
                align="left" width="100"
                header-align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.saleprice" size="mini"
                                   onfocus="this.select()" style="width: 76px" @change="setSalePrice(scope.row)"
                                   :ref='scope.row.saleID'
                                   @keyup.enter.native="validateCounts(scope.row,scope.$index, $event,'saleID')"
                                   @keyup.down.native="validateCounts(scope.row,scope.$index, $event,'saleID')"
                                   @keyup.up.native="validateCounts(scope.row,scope.$index, $event,'saleID')"></el-input>
                </template>
              </el-table-column>
              <!--<el-table-column v-for="(item,xindex) in pricelevel" :key="Math.random()"-->
                               <!--:label="item.name+'价格'"-->
                               <!--align="left" width="100" header-align="center">-->
                <!--<template slot-scope="scope">-->
                  <!--<el-input-number v-model="scope.row.otherprice[item.name+'价格']" :min="0" size="mini"-->
                                   <!--onfocus="this.select()" :controls="false" style="width: 76px"></el-input-number>-->
                <!--</template>-->
              <!--</el-table-column>-->
              <el-table-column
              type="selection" v-if="!onlychangecost"
              width="55">
            </el-table-column>
            </el-table>
          </td>
        </tr>
        <tr class="noborder">
          <td>说&nbsp;&nbsp;&nbsp;&nbsp;明：</td>
          <td colspan="5">
            {{controlData.remark}}
          </td>
        </tr>
      </table>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogSeeVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :loading="loading">保存</el-button>
    </div>
    <input type="file" ref="fileupload" style="display: none;" @change="change1($event)"/>

  </el-dialog>
</template>


<script>

  import {sortByKey} from '@/api/dateUtil';
  import {updatecostprice4FN,updatecostprice4FNorder,getJxcformdetailCost} from '@/api/set/csagreement';
  import {getListData as listLens} from '@/api/set/salefavour';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {listgoodsframe} from '@/api/set/jxcgooddetail'
  import {loadSpecFrame} from '@/plugin/ordercommon'
  import {getControlData,getGoodsListWithPrice} from '@/api/set/goodsprice';

  export default {
    name: 'BatchBuyorderPriceEdit',
    data() {
      let yearnow = new Date().getFullYear()
      let monthnow = new Date().getMonth() + 1
      return {
        ssotoken:"",
        website:"",
        pricelevel:[],
        lensData:[],
        showexcel:true,
        batch: {
          lensrule: '',
          costprice: undefined,
          saleprice: undefined,
        },
        userInfoModel: {},
        data: '2',
        didata: '',
        iddata: '',
        dialogFormVisible: false,
        title: "",
        index: -99,
        seedgoods: [],
        dialogSeeVisible: false,
        formLabelWidth: '120px',
        groupguid: '',
        maxyear: yearnow,
        maxmonth: monthnow,
        cangkucode: '',
        cangkuname: '',
        unitguid: "",
        column: [],
        ptableData: [],
        controlData: {},
        showtitle1: "none",
        form: {  //表单数据
          unitguid: "",
          bookstr: "",
          seedcode: "",
          seedname: "",
          seedinfo: "",
        },
        seedcodeData: [],//选择类别后的商品
        seedcodes: '',
        pingpainame:'',
        tableData: [],
        loading: false,//防止多次提交
        totalnumber: 0,
        totalprice:0,
        pcustomerserial: '',
        multipleSelection:[]
      }

    },
    props:{
      onlychangecost:false,
    },
    methods: {
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      changeLens(cols) {
        if (!this.batch[cols])
          return;
        for (let i in this.multipleSelection) {
          this.multipleSelection[i][cols] = this.batch[cols];
        }
        this.subtotalNumber();
      },

      //给tableData 添加 id，共回车使用
      indexMethod(index) {
        this.tableData[index].id = index
        return index + 1;
      },
      jingjiaupload() {
        this.$refs.fileupload.value = ""
        this.$refs.fileupload.click()
      },
      change1(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          this.$importExcel(event.target.files[0], (data) => {

              let arr = loadSpecFrame(data, "", "");
              if (arr.length > 0) {
                var loadTable=[]
                var addTable=[]
                for (var i in arr) {
                  var MandC = JSON.parse(arr[i].goodsframe)[0];
                  for (let j in this.tableData) {
                    if (this.tableData[j].model == MandC.model) {
                      if (arr[i].costprice > 0)
                        this.tableData[j].costprice = arr[i].costprice;
                      if (arr[i].refsellprice > 0)
                        this.tableData[j].saleprice = arr[i].refsellprice;

                      // var discount=JSON.parse(arr[i].discountdetail)
                      // for(let f in discount) {
                      //   if (discount[f].value > 0) {
                      //     this.tableData[j].otherprice[discount[f].name] = discount[f].value.toFixed(2)
                      //   }
                      // }
                      break;
                    }
                  }
                }
              }
            }
          )
        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
      //选择商品之后执行
      //页面标题
      getTitle() {
        let result = this.userInfoModel.tenantname || ""
        result += "采购订单"
        return result
      },
      getRemark(remark) {
        if (remark) {
          try {
            let temp = JSON.parse(remark)
            var reT=''
            temp.forEach(item => {
              if (item.type == "采购留言") {
                reT= item.msg
              }
            })
            return reT;
          } catch (ex) {
          }
        }
        return ""
      },
      print1() {
        this.showtitle1 = ""
        this.$nextTick(() => {
          this.$print(this.$refs.print1)
          this.showtitle1 = "none"
        })
      },
      saveOnlyCost() {

        var updateCostPrice = [];

        for (let i in this.tableData) {
          if (!this.tableData[i].costprice || this.tableData[i].costprice <= 0) {
            this.$message({
              message: '采购价必填！',
              type: 'warning'
            })
            return
          }

          if (parseFloat(this.tableData[i].costprice) != parseFloat(this.tableData[i].oldcostprice)) {
            updateCostPrice.push(this.tableData[i])
          }

        }
        this.loading = true

        //更新订单采购价
        updatecostprice4FNorder({
          unitguid: this.controlData.unitguid,
          pcustomerserial: this.controlData.pcustomerserial,
          erpserial: this.controlData.erpserial,
          costprice: JSON.stringify(updateCostPrice),
        }).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: '保存成功！',
              type: 'success'
            })
            this.$emit('bindGrid');
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
            this.loading = false
          }
          this.dialogSeeVisible = false;
        });
      },
      saveData() {
        //取出对应的表单详情和数量
        if (this.tableData.length == 0)
          return;

        if(this.onlychangecost){
          this.saveOnlyCost();
          return;
        }

        var updateCostPrice = [];
        var updateSalePrice = [];
        var updateLensRule = [];

        for (let i in this.tableData) {
          if (!this.tableData[i].costprice || this.tableData[i].costprice <= 0) {
            this.$message({
              message: '采购价必填！',
              type: 'warning'
            })
            return
          }
          if (!this.tableData[i].saleprice || this.tableData[i].saleprice <= 0) {
            this.$message({
              message: '市场价必填！',
              type: 'warning'
            })
            return
          }

          if (parseFloat(this.tableData[i].costprice) != parseFloat(this.tableData[i].oldcostprice)) {
            updateCostPrice.push(this.tableData[i])
          }

          if (parseFloat(this.tableData[i].saleprice) != parseFloat(this.tableData[i].oldsaleprice)) {
            updateSalePrice.push(this.tableData[i])
          }

          if (this.tableData[i].lensrule != this.tableData[i].oldlensrule) {
            updateLensRule.push({seedcode: this.tableData[i].seedcode, lensrule: this.tableData[i].lensrule})
          }
          // else {
          //   for (let m in this.pricelevel) {
          //     var name = this.pricelevel[m].name + '价格'
          //     if (parseFloat(this.tableData[i].otherprice[name]) != parseFloat(this.tableData[i].oldotherprice[name])) {
          //       updateSalePrice.push(this.tableData[i])
          //       break;
          //     }
          //   }
          // }
        }
        this.loading = true

        //更新订单采购价
        //更新商品的成本价
        //更新销售价格
        //同步处理发货
        updatecostprice4FN({
          unitguid: this.controlData.unitguid,
          pcustomerserial: this.controlData.pcustomerserial,
          erpserial: this.controlData.erpserial,
          costprice: JSON.stringify(updateCostPrice),
          saleprice: JSON.stringify(updateSalePrice),
          lensrule: JSON.stringify(updateLensRule),
        }).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: '审核成功！',
              type: 'success'
            })
            this.$emit('bindGrid');
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
            this.loading = false
          }
          this.dialogSeeVisible = false;
        });
      },
      checkCostNum(row) {
        if (isNaN(row.costprice)) {
          row.costprice = undefined;
          this.$message.error("数字格式错误！")
          return;
        }
        if(row.costprice<0){
          row.costprice = undefined;
          this.$message.error("请输入大于0的数字！")
          return;
        }
        this.subtotalNumber();
      },
      setSalePrice(row) {
        if (isNaN(row.saleprice)) {
          row.saleprice = undefined;
          this.$message.error("数字格式错误！")
          return;
        }
        if(row.saleprice<=0){
          row.saleprice = undefined;
          this.$message.error("请输入大于0的数字！")
          return;
        }

        // for (let m in this.pricelevel) {
        //   var name = this.pricelevel[m].name + '价格'
        //   if (parseFloat(item.otherprice[name]) <= 0) {
        //     item.otherprice[name] = item.saleprice;
        //   }
        // }
      },
      subtotalNumber() {
        this.totalnumber = 0;
        this.totalprice = 0;
        for (let j in this.tableData) {
          var tn = parseInt(this.tableData[j].totalnumber);
          this.totalnumber += tn;
          if (this.tableData[j].costprice > 0)
            this.totalprice += parseFloat(tn) * parseFloat(this.tableData[j].costprice);
        }
      },
      initData(row) {
        this.initForm();
        this.controlData = row;
        this.controlData.remark=this.getRemark(row.remark)
        this.dialogSeeVisible = true;
        this.showexcel=row.isdistribute==80;
        if(this.onlychangecost){//只修改订单的成本价
          this.showexcel=false;
        }
        getJxcformdetailCost({erpserial: row.erpserial,needdetail:'show'}).then(response => {
          var items = response.data.obj
          var seedcodes = '';
          var index=1;
          for (let i in items) {
            var ps =items[i].packagesize?JSON.parse(items[i].packagesize):''
            if ((';' + seedcodes + ';').indexOf(';' + items[i].seedcode + ';') == -1) {
              seedcodes += (items[i].seedcode ? ';' : '') + items[i].seedcode;

              var row={
                id:index,
                costID:'cost'+index,
                saleID:'sale'+index,
                seedcode: items[i].seedcode,
                seedname: items[i].seedname,
                totalnumber: items[i].totalnumber,
                lensrule:items[i].lensrule?items[i].lensrule:'',
                formproperty: '[{}]',
                color: this.showexcel?ps.C:'',
                model: this.showexcel?ps.M:'',
                packagesize: this.showexcel?items[i].newpackagesize:'',
                costprice: items[i].costprice>0?items[i].costprice:undefined,//成本价
                saleprice: undefined,//销售 市场价
                oldcostprice: items[i].costprice>0?items[i].costprice:0,//成本价
                oldsaleprice: 0,//销售 市场价
                otherprice: {},
                oldotherprice: {}
              };
              index+=1;
              row.oldlensrule=row.lensrule;
              this.tableData.push(row)
              this.$refs.multipleTable.toggleRowSelection(row);
              // for(let m in this.pricelevel){
              //   var name=this.pricelevel[m].name+'价格'
              //   row.otherprice[name]='';//折扣价格
              //   row.oldotherprice[name]='';//折扣价格
              // }

            } else {
              for (let j in this.tableData) {
                if (this.tableData[j].seedcode == items[i].seedcode) {
                  this.tableData[j].totalnumber += items[i].totalnumber;
                  this.tableData[j].packagesize += (this.tableData[j].packagesize ? '、' : '') + items[i].newpackagesize;
                  break;
                }
              }
            }
          }

          //从小到大排序
          if(this.showexcel) {
            this.tableData.sort(function (a, b) {
              if (a.model == b.model)
                return a.color.localeCompare(b.color);
              else
                return a.model.localeCompare(b.model);
            });
          }

          if (seedcodes == ''||this.onlychangecost) {
            this.subtotalNumber();
            return;
          }
          //填成本价
          getGoodsListWithPrice({
            searchseedcodes: seedcodes,
            customerserial: this.controlData.pcustomerserial,
            iscost: 1
          }).then(response => {
            var priceList = response.data.obj;
            for (let j in this.tableData) {
              // if(this.tableData[j].costprice==0) {
                for (let i in priceList) {
                  if (this.tableData[j].seedcode == priceList[i].seedcode) {
                    this.tableData[j].costprice = priceList[i].costprice;
                    break;
                  }
                }
              // }
            }
            this.subtotalNumber();
          });

          //填销售价
          getGoodsListWithPrice({searchseedcodes: seedcodes,iscost:0}).then(response => {
            var priceList = response.data.obj;
            for (let j in this.tableData) {
                for (let i in priceList) {
                  if (this.tableData[j].seedcode == priceList[i].seedcode) {
                    this.tableData[j].saleprice = priceList[i].costprice;
                    this.tableData[j].oldsaleprice = priceList[i].costprice;

                    // var pb = JSON.parse(priceList[i].discountdetail);
                    //
                    // for(let m in this.pricelevel){
                    //   var name=this.pricelevel[m].name+'价格'
                    //   var price=this.getPriceLevel(this.pricelevel[m].value,pb,priceList[i].costprice)
                    //   this.tableData[j].otherprice[name]=price;//折扣价格
                    //   this.tableData[j].oldotherprice[name]=price;//折扣价格
                    // }
                    break;
                  }
                }
            }
          });
        })
      },
      getPriceLevel(level, pb, costprice) {
        for (var rowindex in pb) {
          var row = pb[rowindex]
          if (row.PriceLevel == level) {
            var dc = row.DisCount ? row.DisCount : row.DisCount == 0 ? 0 : 10
            if (dc != 10)
              return parseFloat(0.1 * costprice * dc).toFixed(2);//dc + "折 " +
          }
        }
        return parseFloat(costprice || 0).toFixed(2);
      },
      initForm() {
        this.controlData={}
        this.column = []
        this.tableData = []
        this.unitguid = ""
        this.loading = false
        this.totalnumber = 0
        this.batch.lensrule=''
        this.batch.costprice=undefined
        this.batch.saleprice=undefined
      },
      //回车跳入下一行
      validateCounts(row, index, e,idCol) {
        var begin=false;
        var keyCode = e.keyCode || e.which || e.charCode;
        if (keyCode == 40 || keyCode === 13) {//回车，下方向键
          for(var i=0;i<this.tableData.length;i++) {
            if(this.tableData[i][idCol]==row[idCol]) {
              begin = true;
              continue;
            }

            if(begin){
              this.$refs[row[idCol].toString()].blur();
              this.$refs[this.tableData[i][idCol].toString()].focus();
              break;
            }
          }

        } else if (keyCode == 38) {//上方向键
          for(var i=this.tableData.length-1;i>=0;i--) {

            if(this.tableData[i][idCol]==row[idCol]) {
              begin = true;
              continue;
            }

            if(begin){
              this.$refs[row[idCol].toString()].blur();
              this.$refs[this.tableData[i][idCol].toString()].focus();
              break;
            }
          }
          // this.$refs[Object.keys(this.$refs)[index - 1]].focus();
        }
      },
    },
    mounted() {
      let temp = localStorage.getItem("hpapi_userInfoModel")
      if (temp) {
        this.userInfoModel = JSON.parse(temp);
      }

      getControlData().then(response => {
        this.pricelevel = response.data.obj.pricelevel
      })

      //镜片的价格配置
      listLens({
        offset: 0,
        limit: 100,
        coupontype: 50,
        inuse: 1
      }).then(response => {
        this.lensData = response.data.obj.rows
      }).catch((error) => {
        console.log(error)
      });
    },
    components: {
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }

  .gray1 td {
    color: #C0C4CC;
    background-color: #ebeef5;
  }

  .gray1 input {
    display: none;
  }

</style>





// WEBPACK FOOTER //
// src/components/testorder/buyagreement/BatchBuyorderPriceEdit.vue